import clsx from "clsx";
import get from "lodash/get";
import React, { useEffect, useMemo, useState } from "react";
import { format } from "date-fns";
import { debounce } from "lodash";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Back from "~/components/Icons/arrow-prev2";
import Preloader from "~/components/Preloader";
import Table from "~/components/Table";
import Button from "~/shared/ui/Fields/Button";
import Select from "~/shared/ui/Fields/Select";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { onScrollBottomDealers } from "~/hooks/selectDealerValue";
import { getNameSelection } from "~/libs/getData";
import {
  useGetArchiveDealersInheritanceLazyQuery,
  useGetRegMensLazyQuery,
  useGetReportFileRegMenByDealerByDealerLazyQuery,
  useGetReportFileRegMenByDealerByPeriodLazyQuery,
  useGetReportFileRegMenByDealerConsolidateLazyQuery,
  useGetReportRegMenByDealerByDealerLazyQuery,
  useGetReportRegMenByDealerByPeriodLazyQuery,
  useGetReportRegMenByDealerConsolidateLazyQuery,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";

import { DEALER_OPTIONS_ARCHIVE_PERIOD } from "./options";

import s from "./RegMen.less";

const DealersInheritance = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const setData = useSetLocationData();
  const isEn = language === "en";
  const history = useHistory();
  const goBack = () => {
    history.replace("/dealers/period/");
  };

  const [checkBtn, setCheckBtn] = useState(false);

  const handleCloseModal = () => {
    setData("openModal", "");
  };
  const { notifyReport } = useNotify();
  const [getReportFileRegMenByDealerByDealerLazyQuery] =
    useGetReportFileRegMenByDealerByDealerLazyQuery({
      onCompleted(data) {
        const hash = get(
          data,
          `UserGetter.getReportFileRegMenByDealerByDealer.fileHash`,
        );
        hash && notifyReport(hash);
      },
      fetchPolicy: "no-cache",
    });

  const dealersForSelect = onScrollBottomDealers();

  const { handleSubmit, control, watch, setValue, errors } = useForm({});
  const [tableReport, setTableReport] = useState([]);

  const [
    GetReportRegMenByDealerByDealerLazyQuery,
    ReportRegMenByDealerByDealerLazyQuery,
  ] = useGetArchiveDealersInheritanceLazyQuery({
    onCompleted(data) {
      const globals = get(
        data,
        "DealerRegistryGetter.getArchiveDealersInheritance.items",
        [],
      ).map((dealer) => {
        const arrPeriods = get(dealer, "periods", []);

        return {
          ...dealer,
          idPeriod:
            arrPeriods.length > 0
              ? `${arrPeriods[0]?.id} - ${arrPeriods[arrPeriods.length - 1].id}`
              : "",
          dateStart:
            arrPeriods.length > 0
              ? format(new Date(arrPeriods[0]?.dateStart), "dd.MM.yyyy")
              : "",
          dateEnd:
            arrPeriods.length > 0
              ? format(
                  new Date(arrPeriods[arrPeriods.length - 1]),
                  "dd.MM.yyyy",
                )
              : "",
          DealerName: getNameSelection("DealerName", dealer),
          ArchivePeriodId:
            arrPeriods.length > 0 ? arrPeriods[arrPeriods.length - 1].id : "",
        };
      });
      // if (Object.keys(globals).length > 0) {

      setTableReport(globals);
      // }
    },
    fetchPolicy: "no-cache",
  });

  const onSubmitForm = (data) => {
    GetReportRegMenByDealerByDealerLazyQuery({
      variables: {
        DealerId: data["dealerIdFilter"]?.value,
      },
    });
  };

  const loading = ReportRegMenByDealerByDealerLazyQuery.loading;

  return (
    <>
      <div className={s.wrapper}>
        <div className={s.s_dealer_title}>{t("dealers.succession")}</div>

        <form className={s.formReport} onSubmit={handleSubmit(onSubmitForm)}>
          <>
            <Select
              name={"dealerIdFilter"}
              control={control}
              optionObjects={[...dealersForSelect["dealersForSelect"]]}
              onScrollBottom={dealersForSelect["introspectionHandler"]}
              getSearchText={dealersForSelect["searchDealer"]}
              customClassName={s.width_select}
            />
          </>

          <div>
            <Button
              txtBtn={t("regMen.btnTable")}
              isForm
              orange
              small
              onClick={() => setCheckBtn(true)}
            />

            <Button
              txtBtn={"Назад"}
              onClick={goBack}
              small
              customClassName={s.add_bth}
            >
              <Back />
            </Button>
          </div>
        </form>

        {loading ? (
          <Preloader />
        ) : (
          tableReport.length > 0 && (
            <Table
              options={DEALER_OPTIONS_ARCHIVE_PERIOD}
              items={tableReport}
              loading={ReportRegMenByDealerByDealerLazyQuery.loading}
              sortable={false}
              positionStiki
              type={"dealers"}
              customClassName={clsx(s.dealers_table, {
                // [s.dealers_table_report]: reportSelect.value === "reportAll",
              })}
            />
          )
        )}
      </div>
    </>
  );
};

export default DealersInheritance;
